import { render, staticRenderFns } from "./assignList.vue?vue&type=template&id=538948c2"
import script from "./assignList.vue?vue&type=script&lang=js"
export * from "./assignList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports